// extracted by mini-css-extract-plugin
export default {"tupacGrid":"sn-z","tupacHeader":"tn-z","tupacHeader2":"un-z","tupacMenu":"vn-z","tupacMenu2":"wn-z","tupacMain":"xn-z","tupacMain2":"yn-z"};